import React from 'react';
import Slider from 'react-slick';
import cn from 'classnames';
import GoogleIcon from 'components/IconModule/icons/google';
import StarRating from 'components/StarRating';
import AnimatedContainer from 'components/AnimatedContainer';
import GoogleReviewCard from '../components/GoogleReviewCard';
import { GoogleReviews, GoogleReviewCarouselConfig } from '../constants';
import css from './GoogleReview.module.scss';
import './press-slider.scss';

export default function GoogleReview() {
  return (
    <div className={css.wrapper}>
      <div className={css.titleBlock}>
        <div className={css.title}>View all of our Google Reviews </div>
        <div className={css.logo}>
          <GoogleIcon />
          <StarRating rating={5} fontSize={1.5} />
        </div>
      </div>
      <div className={css.sliderWrapper}>
        <Slider
          {...GoogleReviewCarouselConfig}
          className={cn(css.slider, "press-slider")}
        >
          {GoogleReviews.map((item, i) => (
            <AnimatedContainer key={i}>
              <GoogleReviewCard {...item}/>
            </AnimatedContainer>
          ))}
        </Slider>
      </div>
    </div>
  )
}
